import ForumOutlined from '@mui/icons-material/ForumOutlined';
import HelpOutline from '@mui/icons-material/HelpOutline';
import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import { Divider, IconButton, Stack, Switch, styled, Tooltip, Typography } from '@mui/material';

export interface BetaEnrollmentProps {
  isBetaEnabled: boolean;
  onBetaToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function BetaEnrollment({ isBetaEnabled, onBetaToggle }: BetaEnrollmentProps) {
  return (
    <Stack
      direction="row"
      sx={{ justifyContent: 'left', width: '100%', gap: 3.2, alignItems: 'center' }}
    >
      <Stack>
        <VerifiedOutlined />
      </Stack>
      <Stack
        sx={{
          flexGrow: 1,
        }}
      >
        <Typography
          color="white"
          sx={{
            textTransform: 'uppercase',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: '0.46px',
          }}
        >
          Try the new swimlane beta
        </Typography>
      </Stack>
      <Stack>
        <Tooltip title={isBetaEnabled ? 'Disable beta' : 'Enable beta'}>
          <StyledSwitch
            size="small"
            color="default"
            checked={isBetaEnabled}
            onChange={onBetaToggle}
            $isChecked={isBetaEnabled}
          />
        </Tooltip>
      </Stack>
      <Divider orientation="vertical" sx={{ height: '50%' }} />
      <Stack>
        <Tooltip title="View Documentation">
          <IconButton
            href="https://help.tempo.io/roadmaps/latest/getting-started-in-the-swimlane-beta"
            target="_blank"
            size="small"
            style={{ width: '20px', height: '20px' }}
          >
            <HelpOutline fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
      <Stack>
        <Tooltip title="Submit Feedback">
          <IconButton
            href="https://forms.gle/68BmeYJqAPedWqKr6"
            target="_blank"
            style={{ width: '20px', height: '20px' }}
          >
            <ForumOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
      <Divider orientation="vertical" sx={{ height: '50%' }} />
    </Stack>
  );
}

const StyledSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== '$isChecked',
})<{ $isChecked: boolean }>`
  & .MuiSwitch-track {
    background-color: ${({ $isChecked }) => ($isChecked ? '#FFF' : '#000')};
  }
`;
